import {
  StyledSessionList,
  SessionListControls,
  SessionListContent,
  SessionListHint,
  InternalSessionInfo,
  InternalSession,
  InternalSessionList,
  InternalSessionListWrapper,
  Checkmark,
  PopupTopDecorator
} from '../VsBattlePopup/VsBattlePopup.styled';
import { PlaceMarker, LeaderboardRow, LeaderInfo, ValueLabel } from './Leaderboard.styled';
import { PopupHeader, BroadsiderHudPopup, IconButton } from '../';
import { useEffect, useContext, useState } from 'react';
import { useTokenAuth } from '../../hooks';
import { getLeaderboard } from '../../providers/BasejumpApiProvider';
import { useInView } from "react-intersection-observer";

const LeaderboardData = ({ user, onSelectUser, selectedUser, users, onScrollBottom }) => {
  const { ref, inView, entry } = useInView();

  useEffect(() => {
    if (inView) {
      onScrollBottom();
    }
  }, [inView]);
  return (
    <InternalSessionList>
      <InternalSessionListWrapper>
        {users.map((s, index) => {
           const isOwn = s.id === user.id;
           const isSelected = s.id === selectedUser?.id;
           return (
             <LeaderboardRow key={s.id} $own={isOwn} $selected={isSelected} onClick={() => !isOwn ? onSelectUser(s) : false}>
               <PlaceMarker><ValueLabel>{index + 1}</ValueLabel></PlaceMarker>
               <LeaderInfo $own={isOwn} $selected={isSelected}><ValueLabel>{s.username} - {s.xp} XP</ValueLabel></LeaderInfo>
             </LeaderboardRow>
           );
        })}
        {users.length > 0 && <div ref={ref} style={{ width: '100%' }}/>}
      </InternalSessionListWrapper>
    </InternalSessionList>
  );
};

const LEADERBOARD_PAGE_SIZE = 50;

const Leaderboard = ({ onSelectOpponent }) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [leaderboardPage, setLeaderboardPage] = useState(0);
  const [canShowMore, setCanShowMore] = useState(true);
  const [users, setUsers] = useState([]);
  const { basejumpToken, user } = useTokenAuth();

  const fetchLeaders = async () => {
    const leaders = await getLeaderboard(basejumpToken, LEADERBOARD_PAGE_SIZE, leaderboardPage * LEADERBOARD_PAGE_SIZE);
    if (leaders.length < LEADERBOARD_PAGE_SIZE) {
      setCanShowMore(false);
    }
    setUsers([...users, ...leaders]);
  };

  useEffect(() => {
    fetchLeaders();
  }, [leaderboardPage]);

  const onSelectUser = (user) => {
    setSelectedUser(user);
    const { avatar } = user;
    if (avatar) {
      avatar.owner = {id: user.id, user_name: user.username, isNpc: false, xp: user.xp };
      onSelectOpponent(avatar);
    }
  };

  const onScrollBottom = () => {
    if (canShowMore) {
      setLeaderboardPage(leaderboardPage + 1);
    }
  };

  return (
    <BroadsiderHudPopup overwrightWidth='25vw' overwrightMinWidth='23rem'>
      <PopupTopDecorator/>
      <StyledSessionList>
        <PopupHeader title='Leaderbord' />
        <SessionListContent>
          <LeaderboardData user={user} onSelectUser={onSelectUser} selectedUser={selectedUser} users={users} onScrollBottom={onScrollBottom}/>
        </SessionListContent>
      </StyledSessionList>
    </BroadsiderHudPopup>
  );
};

export default Leaderboard;
